<template>
  <div class="relative bg-gray-50 pt-10 pb-20 px-4 sm:px-6 lg:pt-10 lg:pb-28 lg:px-8">
    <div class="absolute inset-0">
      <div class="bg-white h-1/3 sm:h-2/3" />
    </div>
    <div class="relative max-w-7xl mx-auto">
      <div class="text-center border-b border-gray-200 pb-10">
        <h2 class="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl">
          Free Blocks to enhance your Notion pages
        </h2>
        <p class="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4">
          No login, zero tracking, unique blocks to help your teamwork flow.
        </p>
        <p class="mt-3 max-w-2xl mx-auto text-xl text-indigo-700 font-bold sm:mt-4">
          Get the Notion embed code in one click!
        </p>
      </div>
      <div class="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
        <BlockPalette />
        <BlockUnsplash />
        <BlockQR />
      </div>
    </div>
  </div>
</template>

<script>
import BlockQR from '@/components/BlockQR.vue'
import BlockPalette from '@/components/BlockPalette.vue'
import BlockUnsplash from '@/components/BlockUnsplash.vue'

export default {
  data() {
    return {
    }
  },
  components: {
    BlockQR,
    BlockPalette,
    BlockUnsplash,
  }
}
</script>
